const CK = "pos_cache:";
const QK = "pos_offline_queue";
const CACHEABLE = ["/products", "/categories", "/promotions/active", "/settings", "/auth/me", "/customers", "/shifts/current", "/permissions"];

const hasParams = (p) => p && Object.values(p).some((v) => v !== "" && v != null && v !== false);
export const isCacheable = (cfg) => cfg?.method === "get" && CACHEABLE.includes(cfg.url) && !hasParams(cfg.params);

export const cacheSet = (url, data) => {
  try {
    localStorage.setItem(CK + url, JSON.stringify(data));
  } catch (e) {
    /* storage full: skip cache */
  }
};
export const cacheGet = (url) => {
  const v = localStorage.getItem(CK + url);
  return v ? JSON.parse(v) : undefined;
};
export const clearCache = () => Object.keys(localStorage).filter((k) => k.startsWith(CK)).forEach((k) => localStorage.removeItem(k));

export const isNetErr = (e) => !!e && !e.response;

export const getQueue = () => JSON.parse(localStorage.getItem(QK) || "[]");
const saveQueue = (q) => {
  localStorage.setItem(QK, JSON.stringify(q));
  window.dispatchEvent(new Event("pos-queue"));
};
export const addToQueue = (item) => saveQueue([...getQueue(), item]);

let syncing = false;
export async function syncQueue(api) {
  if (syncing || !navigator.onLine) return { ok: 0, failed: 0 };
  syncing = true;
  let ok = 0;
  let failed = 0;
  try {
    for (const item of getQueue()) {
      try {
        await api.post("/transactions", item.body);
        saveQueue(getQueue().filter((x) => x.body.client_id !== item.body.client_id));
        ok++;
      } catch (e) {
        if (isNetErr(e)) break;
        failed++;
        const d = e.response?.data?.detail;
        saveQueue(getQueue().map((x) => (x.body.client_id === item.body.client_id ? { ...x, error: typeof d === "string" ? d : "Gagal sinkron" } : x)));
      }
    }
  } finally {
    syncing = false;
  }
  return { ok, failed };
}

export const newClientId = () => (crypto.randomUUID ? crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).slice(2));

export function buildOfflineTx({ cart, promoMap, discount, taxPercent, payload, user, clientId }) {
  const now = new Date();
  const p2 = (n) => String(n).padStart(2, "0");
  const invoice = `OFF-${now.getFullYear()}${p2(now.getMonth() + 1)}${p2(now.getDate())}-${p2(now.getHours())}${p2(now.getMinutes())}${p2(now.getSeconds())}`;
  const items = cart.map((i) => {
    const pd = promoMap[i.product.id] || { discount: 0, name: "" };
    return { product_id: i.product.id, name: i.product.name, barcode: i.product.barcode, price: i.product.price, cost: i.product.cost || 0,
      qty: i.qty, discount: pd.discount, promo_name: pd.name, subtotal: i.product.price * i.qty - pd.discount };
  });
  const subtotal = items.reduce((a, b) => a + b.subtotal, 0);
  const after = subtotal - discount;
  const tax = Math.round((after * taxPercent) / 100);
  const total = after + tax;
  const paid = payload.payment_method === "tunai" ? Math.max(payload.paid, total) : total;
  return {
    id: clientId, client_id: clientId, invoice, offline: true, pending: true, items, subtotal, discount, tax, tax_percent: taxPercent,
    total, paid, change: paid - total, payment_method: payload.payment_method, customer_id: payload.customer_id || "",
    customer_name: payload.customer_name || "", points_redeemed: 0, points_discount: 0, points_earned: 0,
    cashier_id: user.id, cashier_name: user.name, status: "selesai", created_at: now.toISOString(),
  };
}
